import React from "react";

const RequestMoneyBus = (props) => {
  const options = [
    {
      text: 'Qu’est-ce que la fonction Demander de fonds de Virement INTERAC?',
      handler: props.actionProvider.RequestMoneyBus1,
      id: 1
    },
    {
      text: 'Je suis en train d’envoyer une facture à un client par Virement INTERAC et j’aimerais ajouter le numéro de facture, le numéro de TVH et l’adresse de l’entreprise. Où dois-je ajouter ces renseignements?',
      handler: props.actionProvider.RequestMoneyBus2,
      id: 2
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container etransfer-products'>{optionsMarkup}</div>;
};

export default RequestMoneyBus;